import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/currentOrderStatuses', request)
}

export {get}
